import { ShieldOff } from "lucide-react"
import { EmptyState } from "@/shared/ui/empty-state"
import { PageShell } from "@/shared/ui/page-shell"

/** Раздел открыт не для этой роли. Один экран на всю панель, чтобы формулировка была одна. */
export function AccessDenied({ title }: { title: string }) {
	return (
		<PageShell title={title}>
			<EmptyState icon={ShieldOff} title="Доступ запрещён">
				Раздел открыт не для вашей роли. Если доступ нужен, попросите администратора.
			</EmptyState>
		</PageShell>
	)
}
